import Button from 'components/controls/Button';
import { FormFieldData, useForm } from 'modules/forms';
import { useCallback, useState } from 'react';
import { OpportunityEntity } from 'shared/types/domain/OpportunityEntity';
import {
   StyledActionsContainer,
   StyledObservationHeader,
   StyledActionsRow,
   StyledActionsCol
} from 'shared/styled/ObservationHeader.styled';
import { IFormIsValidFunction } from 'modules/forms/types/IFormIsValidFunction';
import { Prompt } from 'react-router-dom';
import { ObservationFileEntity } from 'shared/types/file/ObservationFileEntity';
import { ActionResponse } from 'modules/errors';

interface OpportunityHeaderProps {
   onSave: (
      formData: FormFieldData<OpportunityEntity> | undefined,
      fileData: ObservationFileEntity[] | undefined,
      isValid: IFormIsValidFunction
   ) => Promise<ActionResponse>;
   isLoading: boolean;
   files: ObservationFileEntity[];
}

const NewOpportunityHeader = ({ onSave, isLoading, files }: OpportunityHeaderProps) => {
   const { formData, isValid } = useForm<OpportunityEntity>();
   const [formSubmitted, setFormSubmitted] = useState<boolean>(false);

   const hasChanges = useCallback((): boolean => {
      var dataChanged =
         !!formData?.depotPcId ||
         !!formData?.whatHappened ||
         !!formData?.whoShouldBeCommended ||
         !!formData?.reporterType ||
         !!formData?.reachId ||
         !!formData?.processId ||
         (!formData?.anonymousEntry && !!formData?.reporterContactName) ||
         (!formData?.anonymousEntry && !!formData?.reporterPhoneNumber) ||
         (!formData?.anonymousEntry && !!formData?.reporterEmail) ||
         files?.length > 0;

      if (dataChanged) {
         window.onbeforeunload = () => true;
      } else {
         window.onbeforeunload = null;
      }
      return dataChanged;
   }, [formData, files]);

   const saveNearMiss = async () => {
      if (!formSubmitted) {
         setFormSubmitted(true);
         await onSave(formData, files, isValid).then(() => {
            setFormSubmitted(false);
         });
      }
   };

   return (
      <StyledObservationHeader>
         <Prompt when={!formSubmitted && hasChanges()} message={'You have unsaved changes to the current near miss, are you sure you wish to navigate away?'} />
         <h1>New Opportunity</h1>
         <StyledActionsContainer fluid>
            <StyledActionsRow>
               <StyledActionsCol xs={12} style={{ justifyContent: 'flex-end' }}>
                  <Button
                     isLoading={isLoading}
                     text={'Submit'}
                     onClick={saveNearMiss}
                     iconName={'Save'}
                     disabled={!isValid(false)}
                  />
               </StyledActionsCol>
            </StyledActionsRow>
         </StyledActionsContainer>
      </StyledObservationHeader>
   );
};

export default NewOpportunityHeader;
